
	<button type="button" kendoButton class="k-button medium"
		(click)="togglePopup()" [svgIcon]="projectService.svgIcons.barcodeOutlineIcon">
	</button>

	<kendo-dialog [title]="dialogTitle" *ngIf="isPopupShown"
		(close)="action(false)" [width]="850" [maxHeight]="950">
		<app-offer></app-offer>
		<kendo-dialog-actions *ngIf="!exportInProgress">
			<button kendoButton (click)="action(false)" i18n="Dialogs|'Cancel' button">Cancel</button>
			<button kendoButton (click)="action(true)" primary="true" [disabled]="isExportBtmDisabled" i18n="Dialogs|'Confirm' button">Confirm</button>
		</kendo-dialog-actions>
	</kendo-dialog>
